'use es6';

import FilterEditorOrGroupHeader from './FilterEditorOrGroupHeader';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class FilterEditorOrGroupCondition extends PureComponent {
  render() {
    const {
      conditionStyle,
      handleClone,
      handleRemove,
      isReadOnly,
      isTitleVisible,
      renderAndGroupConditions
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium-test": "FilterEditorOperator-orGroup",
      children: [/*#__PURE__*/_jsx(FilterEditorOrGroupHeader, {
        handleClone: handleClone,
        handleRemove: handleRemove,
        isReadOnly: isReadOnly,
        isTitleVisible: isTitleVisible
      }), /*#__PURE__*/_jsx(UITile, {
        closeable: false,
        compact: true,
        style: conditionStyle,
        children: /*#__PURE__*/_jsx(UITileSection, {
          className: "p-all-2",
          children: renderAndGroupConditions()
        })
      })]
    });
  }
}
FilterEditorOrGroupCondition.propTypes = {
  conditionStyle: PropTypes.shape({
    backgroundColor: PropTypes.string,
    borderColor: PropTypes.string
  }),
  handleClone: PropTypes.func,
  handleRemove: PropTypes.func,
  isReadOnly: PropTypes.bool,
  isTitleVisible: PropTypes.bool,
  renderAndGroupConditions: PropTypes.func
};